import styled from "styled-components";

export const HeaderWrapper = styled.div`
  min-height: 61px;
  background: ${props => props.theme.primary};
  padding: 0 17px;
  display: flex;

  @media print {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/style.js